import './PriceLineHeaderStyle.less';

import { Tooltip } from '@opendoor/bricks';
import React from 'react';

interface IPriceLineHeaderProps {
  className?: string;
  titleText: string;
  titleTooltipText?: string;
  lowerBoundDollars: number;
  upperBoundDollars: number;
}

const defaultProps: Partial<IPriceLineHeaderProps> = {
  className: '',
};

const PriceLineHeader: React.SFC<IPriceLineHeaderProps> = props => (
  <div className={`od-price-line-header ${props.className}`}>
    <div className="od-price-line-header__blue-gradient">
      <div>
        <small>{props.titleText}</small>
        {props.titleTooltipText && <Tooltip>{props.titleTooltipText}</Tooltip>}
      </div>
      <h2 className="od-price-line-header__value-range">
        ${props.lowerBoundDollars.toLocaleString()} &ndash; $
        {props.upperBoundDollars.toLocaleString()}
      </h2>
      {props.children}
    </div>
  </div>
);

PriceLineHeader.defaultProps = defaultProps;

export default PriceLineHeader;
